import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { url } from '../utils/config';
import loaderStateAtom from "../atoms/loaderStateAtom";
import carListAtom from "../atoms/carListAtom";
import axios from "axios";
import makeStateAtom from "../atoms/makeStateAtom";
import { useNavigate } from "react-router-dom";
import navHeaderAtom from "../atoms/navHeaderAtom";
import { containerOne } from "../utils/style";


function MakeSelector() {
    const [ carList, setCarList ] = useRecoilState(carListAtom);
    const [ make, setMake ] = useRecoilState(makeStateAtom);
    const [ showLoader, setShowLoader ] = useRecoilState(loaderStateAtom)
    const [ header, setHeader ] = useRecoilState(navHeaderAtom);

    const navigate = useNavigate()

    useEffect(() => {
        setHeader('Choose Your Make')
        if(!carList) {
            getCarList()
        }
    }, [])


    async function getCarList() {
        try {
            setShowLoader(true)
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(url + '/cars', { headers })
            // console.log(data)
            setCarList(data.data)
            setShowLoader(false)
        } catch (error) {
            console.log(error)
            setShowLoader(false)
        }
    }

    function getMakeList() {
        try { 
            if(carList) {
                const make = [];
                carList.forEach(car => {
                    if(!make.includes(car.make)) {
                        make.push(car.make)
                    }
                })
                return make;
                // console.log(make)
            }
        } catch (error) {
            console.log(error)
        }
    }

    function selectMakeAndNavigate(make) {
        try {
            setMake(make);
            navigate('/model_selector');
        } catch (error) {
            console.log(error)
        }
    }


    return(
        <div className={containerOne}>
            <div className="">
                {
                    getMakeList()?.map((make, i) => 
                    <div 
                        key={i} 
                        onClick={() => selectMakeAndNavigate(make)} 
                        className='p-4 rounded-lg shadow-lg mb-4 flex justify-between'
                    >
                        <div>
                            <img />
                            <div className="text-md font-semibold">{make}</div>
                        </div>
                        <div className="text-sm text-customOne font-semibold cursor-pointer">{`View Model >`}</div>
                    </div>)
                }
            </div>
        </div>
    )
}

export default MakeSelector;